export default __webpack_public_path__ + "static/media/HVco04.a4012991.png";